import { useState } from "react";
import { Activity, BarChart3, FileCheck2, Flag, Gem, Globe2, History, ListFilter, LogOut, Menu, Radio, ShieldAlert, ShieldCheck, UserRoundSearch, Users, X } from "lucide-react";
import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const NAV_ITEMS = [
  ["/overview", "Overview", BarChart3], ["/feed", "Feed", ListFilter], ["/presence", "Presence", UserRoundSearch], ["/earnings", "Earnings", Gem], ["/reports", "Reports", Flag], ["/takedowns", "Takedowns", ShieldAlert], ["/users", "Users", Users],
  ["/verifications", "Verifications", FileCheck2], ["/live", "Live", Radio], ["/map", "Map", Globe2], ["/audit", "Audit", History],
];

export const Shell = ({ user, children }) => {
  const { logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const name = user?.display_name || user?.name || user?.email || "Administrator";

  return (
    <div className="app-shell">
      <button className="mobile-menu-button" onClick={() => setMobileOpen(true)} aria-label="Open navigation" data-testid="open-navigation-button"><Menu /></button>
      <aside className={`sidebar ${mobileOpen ? "open" : ""}`} data-testid="admin-sidebar">
        <div>
          <div className="brand-row">
            <div className="brand-mark"><Activity size={21} /></div>
            <div><strong>AuraLive</strong><span>CONTROL</span></div>
            <button className="mobile-close" onClick={() => setMobileOpen(false)} aria-label="Close navigation" data-testid="close-navigation-button"><X /></button>
          </div>
          <div className="environment-line"><i />Production API</div>
          <nav aria-label="Admin navigation">
            {NAV_ITEMS.map(([to, label, Icon]) => <NavLink key={to} to={to} onClick={() => setMobileOpen(false)} className={({ isActive }) => isActive ? "active" : ""} data-testid={`nav-${label.toLowerCase()}-link`}><Icon size={18} /><span>{label}</span></NavLink>)}
          </nav>
        </div>
        <div className="operator-card" data-testid="signed-in-operator">
          <div className="operator-avatar"><ShieldCheck size={18} /></div>
          <div className="operator-copy"><strong>{name}</strong><span>{user?.role?.replaceAll("_", " ")}</span></div>
          <button className="icon-button" onClick={logout} aria-label="Log out" title="Log out" data-testid="logout-button"><LogOut size={17} /></button>
        </div>
      </aside>
      {mobileOpen && <button className="sidebar-scrim" onClick={() => setMobileOpen(false)} aria-label="Close navigation overlay" data-testid="navigation-overlay" />}
      <main className="main-content">{children}</main>
    </div>
  );
};